import { render, staticRenderFns } from "./videodetail.vue?vue&type=template&id=351a744c&scoped=true"
import script from "./videodetail.vue?vue&type=script&lang=js"
export * from "./videodetail.vue?vue&type=script&lang=js"
import style0 from "./videodetail.vue?vue&type=style&index=0&id=351a744c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a744c",
  null
  
)

export default component.exports